/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomCaptionPage
 */
export interface CustomCaptionPage {
    /**
     * 
     * @type {string}
     * @memberof CustomCaptionPage
     */
    captionBody?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomCaptionPage
     */
    addPageBreakAfterCaption?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CustomCaptionPage
     */
    requestDocumentTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomCaptionPage
     */
    responseDocumentTitle?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomCaptionPage
     */
    uppercaseTitle?: boolean | null;
}

export function CustomCaptionPageFromJSON(json: any): CustomCaptionPage {
    return CustomCaptionPageFromJSONTyped(json, false);
}

export function CustomCaptionPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomCaptionPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'captionBody': !exists(json, 'captionBody') ? undefined : json['captionBody'],
        'addPageBreakAfterCaption': !exists(json, 'addPageBreakAfterCaption') ? undefined : json['addPageBreakAfterCaption'],
        'requestDocumentTitle': !exists(json, 'requestDocumentTitle') ? undefined : json['requestDocumentTitle'],
        'responseDocumentTitle': !exists(json, 'responseDocumentTitle') ? undefined : json['responseDocumentTitle'],
        'uppercaseTitle': !exists(json, 'uppercaseTitle') ? undefined : json['uppercaseTitle'],
    };
}

export function CustomCaptionPageToJSON(value?: CustomCaptionPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'captionBody': value.captionBody,
        'addPageBreakAfterCaption': value.addPageBreakAfterCaption,
        'requestDocumentTitle': value.requestDocumentTitle,
        'responseDocumentTitle': value.responseDocumentTitle,
        'uppercaseTitle': value.uppercaseTitle,
    };
}


